import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import "../helpers/scroll-tracker";

gsap.registerPlugin(ScrollTrigger);

class ProductLandingNavigation extends HTMLElement {
  constructor() {
    super();

    this.triggers = [];

    this._pinBar();
    this._initLinkTriggers();
    this._appendComplexProducts();
    this._addProductAnimations();
    this._integrateWithStickyHeader();

    setTimeout(() => {
      this.triggers.forEach((trigger) => trigger.refresh());
    }, 4000);
  }

  _pinBar() {
    const mm = gsap.matchMedia();

    mm.add("(max-width: 1279px)", () => {
      const mainContent = this.querySelector(
        ".product-landing-navigation__main-content"
      );
      const footer = document.querySelector(".footer");

      // Add some space for the sticky bar below footer
      footer.style.marginBottom = `${mainContent.getBoundingClientRect().height
        }px`;

      const onToggle = (self) =>
        mainContent.classList.toggle("sticking", self.isActive);

      this.triggers.push(
        ScrollTrigger.create({
          trigger: this,
          start: "bottom bottom-=80px",
          end: "max+=100px",
          onToggle,
        })
      );
    });
  }

  _initLinkTriggers() {
    const sections = document.querySelectorAll(".shopify-section");

    const setScrollOffset = () => {
      // let offset = 0;
      // if (window.matchMedia("(max-width: 991px)").matches) {
      //   offset = 20;
      // } else {
      // }
      const offset = this.getBoundingClientRect().height;

      this.offset = offset;

      document.body.style.setProperty(
        "--product-landing-navigation-scroll-offset",
        `${offset}px`
      );
    };

    setScrollOffset();

    window.addEventListener("resize", setScrollOffset);

    this.querySelectorAll("[data-product-landing-navigation-link]").forEach(
      (link) => {
        const sectionNumber = parseInt(
          link.dataset.productLandingNavigationLink,
          10
        );
        const section = sections[sectionNumber - 1];

        if (!section) return;

        link.href = `#${section.id}`;

        link.addEventListener("click", (e) => {
          e.preventDefault();
          const targetTop = section.offsetTop;
          const scrollUp = targetTop <= window.scrollY;
          const top = targetTop - this.offset;

          // Smooth scroll causes some quirks so add a "Close enough" deadband to avoid scrolling
          // when user clicks link multiple times.
          if (Math.abs(window.scrollY - top) < 100) return;

          window.headerIgnoreScroll = scrollUp;
          window.scroll({ top, left: 0, behavior: 'smooth' });
        });

        this.triggers.push(
          ScrollTrigger.create({
            trigger: section,
            start: "top 50%",
            end: "bottom 50%",
            onToggle: (self) =>
              link.classList.toggle("text-strong", self.isActive),
          })
        );
      }
    );
  }

  get headerHeight() {
    return document.querySelector('.header')?.offsetHeight || 0;
  }

  _appendComplexProducts() {
    const templates = document.querySelectorAll(
      "[data-product-landing-navigation-template]"
    );
    const leftWrapper = this.querySelector(
      ".product-landing-navigation__left-content-wrapper"
    );
    const rightWrapper = this.querySelector(
      ".product-landing-navigation__right-content-wrapper"
    );

    templates.forEach((template) => {
      const leftContent = template.content
        .querySelector(".product-landing-navigation__left-content")
        .cloneNode(true);
      const rightContent = template.content
        .querySelector(".product-landing-navigation__right-content")
        .cloneNode(true);

      [leftContent, rightContent].forEach((el) => {
        el.style.display = "none";
        el.dataset.sectionId = template.parentNode.dataset.sectionId;
      });

      leftWrapper.append(leftContent);
      rightWrapper.append(rightContent);
    });
  }

  _addProductAnimations() {
    this.contentWrappers = [
      this.querySelector(".product-landing-navigation__left-content-wrapper"),
      this.querySelector(".product-landing-navigation__right-content-wrapper"),
    ];

    document.querySelectorAll("complex-product-feature").forEach((section) => {
      const { sectionId } = section.dataset;

      const targetContent = this.querySelectorAll(
        `[data-section-id="${sectionId}"]`
      );

      const onToggle = (self) => {
        if (self.isActive) {
          this.contentWrappers.forEach((wrapper) => {
            [...wrapper.children].forEach((child) => {
              child.style.display = "none";
            });
          });

          targetContent.forEach((content) => {
            content.style.display = null;
          });
        }
      };

      this.triggers.push(
        ScrollTrigger.create({
          trigger: section,
          start: "top 50%",
          end: "bottom 50%",
          onToggle,
        })
      );
    });
  }

  _integrateWithStickyHeader() {
    const shopifySection = this.closest(
      ".shopify-section--product-landing-navigation"
    );

    const header = document.querySelector(".header");

    const onToggle = (self) => {
      shopifySection.classList.toggle(
        "shopify-section--sticking",
        self.isActive
      );
    };

    ScrollTrigger.create({
      trigger: shopifySection,
      start: "top top+=2px",
      end: "max",
      onToggle,
    });
  }
}

if (!customElements.get("product-landing-navigation")) {
  customElements.define("product-landing-navigation", ProductLandingNavigation);
}
